<template>
    <div class="ba6-code-inputs ba-w-100 ba-flex ba-jc-center ba-gp-1">
        <input type="tel" :class="['ba-input ba6-code-input', !code.input1 ? 'ba-error' : '']" maxlength="1" autocomplete="off" @paste="onPasteCode" v-model="code.input1" @keyup="handleKeyUpCode(0, code.input1)"  autofocus />
        <input type="tel" :class="['ba-input ba6-code-input', !code.input2 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input2" @keyup="handleKeyUpCode(1, code.input2)" />
        <input type="tel" :class="['ba-input ba6-code-input', !code.input3 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input3" @keyup="handleKeyUpCode(2, code.input3)" />
        <input type="tel" :class="['ba-input ba6-code-input', !code.input4 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input4" @keyup="handleKeyUpCode(3, code.input4)" />
        <input type="tel" :class="['ba-input ba6-code-input', !code.input5 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input5" @keyup="handleKeyUpCode(4, code.input5)" />
        <input type="tel" :class="['ba-input ba6-code-input', !code.input6 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input6" @keyup="handleKeyUpCode(5, code.input6)" v-on:keyup.enter="sendCode()" />
        <input v-if="qtyInputs == 7" type="tel" :class="['ba-input ba6-code-input', !code.input7 ? 'ba-error' : '']" maxlength="1" autocomplete="off" v-model="code.input7" @keyup="handleKeyUpCode(6, code.input7)" v-on:keyup.enter="sendCode()" />
    </div>
</template>

<script>
export default {
    name: "ba6-code-inputs",
    props: ['getCodeInput', 't', 'setCode', 'qtyInputs'],
    data() {
      return {
        code: {
            input1: '',
            input2: '',
            input3: '',
            input4: '',
            input5: '',
            input6: '',
            input7: ''
        },
        hasPaste: false
      }
    },
    methods: {
        sendCode() {
            if(this.validateFieldsCode2Fa)
            {
                this.getCodeInput(3);
            }
            else
            {
                alertMsg('error', this.t.complete_correctly_fields);
            }
        },
        onPasteCode(evt){
            let code = Object.values(evt.clipboardData.getData('text'));
            this.code.input1 = code[0];
            this.code.input2 = code[1];
            this.code.input3 = code[2];
            this.code.input4 = code[3];
            this.code.input5 = code[4];
            this.code.input6 = code[5];
            this.hasPaste = true;
            if(this.qtyInputs == 7)
            {
                this.code.input7 = code[6];

            }
        },
        getCompleteCode(){
            return this.code.input1 + this.code.input2 + this.code.input3 + this.code.input4 + this.code.input5 + this.code.input6 + this.code.input7;
        },
        handleKeyUpCode(inputRef, data){
            const inputs = document.querySelectorAll('.ba6-code-input');
            this.setCode(this.validateFieldsCode2Fa, this.getCompleteCode());

            if(data)
            {
                if(inputRef < (this.qtyInputs - 1))
                {
                    if(!this.hasPaste)
                    {
                        inputs[inputRef+1].focus();
                    }
                    else
                    {
                        inputs[this.qtyInputs - 1].focus();
                        this.hasPaste = false;
                    }
                }
            }
            else
            {
                if(inputRef > 0)
                {
                    inputs[inputRef-1].focus();
                }
            }
        },
    },
    computed: {
        validateFieldsCode2Fa(){
            let verify = this.code;
            if(this.qtyInputs == 6)
            {
                verify = {
                    input1: this.code.input1,
                    input2: this.code.input2,
                    input3: this.code.input3,
                    input4: this.code.input4,
                    input5: this.code.input5,
                    input6: this.code.input6,
                }
            }
            return Object.values(verify).every(c => !c == false);
        }
    }
}
</script>

<style scoped lang="scss">
    .ba6-code-input{
        width: 50px;
        height: 50px;
        text-align: center;
    }
</style>



// WEBPACK FOOTER //
// resources/office/js/components/office-v6/account-settings/components/CodeInputs.vue